import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticatedUser } from '../useAuthenticatedUser';

/**
 * Hook for managing login page state.
 * Handles detection of already-logged-in users and provides
 * profile information and navigation actions.
 */
export interface UseLoginPageStateResult {
  profile:
    | {
        username: string;
        userId: string;
      }
    | undefined;
  isProbablyLoggedIn: boolean;
  isLoggedIn: boolean;
  isLoading: boolean;
  continueToHome: () => void;
  logout: () => void;
}

export function useLoginPageState(): UseLoginPageStateResult {
  const navigate = useNavigate();
  const { isProbablyLoggedIn, isLoggedIn, profile, isLoading } = useAuthenticatedUser();

  const continueToHome = useCallback(() => {
    navigate('/home');
  }, [navigate]);

  const logout = useCallback(() => {
    navigate('/signout');
  }, [navigate]);

  return {
    isProbablyLoggedIn,
    profile,
    isLoggedIn,
    isLoading,
    continueToHome,
    logout,
  };
}
